export enum ReportComplexity {
  EASY = "EASY",
  STANDARD = "STANDARD",
  COMPLEX = "COMPLEX",
}

export default ReportComplexity;
